const updateLinup = (state = {}, action = {}) => {
    const {
        type = null,
        datasource,
        data = {}
    } = action;

    if (type === 'dataEngine_update_response' ) {

        if (datasource === 'gumbo') {
            const {
                liveData: {
                    boxscore = {}
                } = {},
                gamePk,
                gameData: {
                    teams = {}
                } = {}
            } = data;

            const newData = {
                boxscore,
                teams,
                gamePk

            }
            return {...state, ...{gumbo: newData}};
        }

        if (datasource === 'schedule') {

            const { teams } = data || {};
            const newData = {
                teams,
                gamePk: action?.params?.gamePk
            }
            return {...state, ...{schedule: newData}}
        }


        if (datasource === 'awaylineup') {
            const newData = {
                data,
                gamePk: action?.params?.gamePk
            }
            return {...state, ...{awayLineup: newData}};
        }

        if (datasource === 'homelineup') {
            const newData = {
                data,
                gamePk: action?.params?.gamePk
            }
            return {...state, ...{homeLineup: newData}};
        }

    }

    return state;
};

export default updateLinup;
